import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Step, createProvider } from '@app/shared/IFE/step/step/step';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { EvSimulatorSteps } from '../../models/simulator';
import { BooleanQuestionValues } from 'src/app/modules/evc-quote/models/constants';
import { NotificationType } from '@app/shared/IFE/components/notification/notification.component';

@Component({
  selector: 'app-existing-client',
  providers: [createProvider(ExistingClientComponent)],
  templateUrl: './existing-client.component.html',
  styleUrls: ['./existing-client.component.scss'],
})
export class ExistingClientComponent extends Step {
  readonly formName = 'existingClient';
  readonly stepName = EvSimulatorSteps.existingClient;
  readonly evSimulatorSteps = EvSimulatorSteps;
  readonly booleanQuestionValues = BooleanQuestionValues;
  readonly notificationType = NotificationType;

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  protected buildForm() {
    const group = {};
    group[this.formName] = new UntypedFormControl('', [Validators.requiredTrue]);
    this.control = new UntypedFormGroup(group);
    this.subscribeToValueChanges(true);
  }

  writeValue(value) {
    super.writeValue({ [this.formName]: value });
  }

  proceedToNext() {
    this.control.get(this.formName).patchValue(true);
    this.navigate();
  }

  protected valueChanges(values) {
    for (const [key, value] of Object.entries(values)) {
      this.control.get(key).patchValue(value, { emitEvent: false });
    }
    super.valueChanges(values[this.formName]);
  }
}
